import React from 'react'
import Button from "../../component/Button/Button";
import Modal from "react-bootstrap/Modal";
import {Form} from "react-bootstrap";
import {faTrash, faXmarkCircle} from "@fortawesome/free-solid-svg-icons";

class DeleteKey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            confirmKey: '',
            errorMessage: '',
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirmKeyChange = this.handleConfirmKeyChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleShow() {
        this.setState({show: true, confirmKey: '', errorMessage: ''});
    }

    handleClose() {
        this.setState({show: false, confirmKey: '', errorMessage: ''});
    }

    handleConfirmKeyChange(event) {
        this.setState({confirmKey: event.target.value, errorMessage: ''});
    }

    handleDelete() {
        if (this.state.confirmKey === this.props.s3Key) {
            this.props.delete(this.props.s3Key);
            this.handleClose();
        } else {
            this.setState({errorMessage: `"${this.state.confirmKey}" does not match the key "${this.props.s3Key}"`});
        }
    }

    render() {
        const { s3Key } = this.props;
        const { show, confirmKey, errorMessage } = this.state;

        return <>
            <Button className="secondary-outline btn btn-md" faIcon={faTrash} label="Delete" onClick={this.handleShow}/>

            <Modal show={show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Permanently delete key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete key: <strong>{s3Key}</strong>?</p>
                    <p>To confirm, type the key below:</p>
                    <Form.Control
                        type="text"
                        placeholder={s3Key}
                        value={confirmKey}
                        onChange={this.handleConfirmKeyChange}
                    />
                    {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="cancel-outline btn" faIcon={faXmarkCircle} label="Cancel" onClick={this.handleClose}/>
                    <Button className="secondary btn" faIcon={faTrash} label="Delete" onClick={this.handleDelete}/>
                </Modal.Footer>
            </Modal>
        </>
    }
}

export default DeleteKey